import defaults from "lodash/defaults";
import extend from "lodash/extend";
import Parser from "express-useragent";
import platform from "platform";

export default class Device {
  browser;

  isAndroid;

  isDesktop;

  isEdge;

  isIE;

  isiPad;

  isiPhone;

  isiPod;

  isSafari;

  isTablet;

  navigator;

  options;

  os;

  platform;

  screenHeight;

  screenWidth;

  source;

  version;

  constructor(options) {
    this.navigator = options.navigator;
    const userAgent = this.navigator.userAgent;

    defaults(options, {
      forceDash: false,
      forceHLS: false,
    });
    this.options = options;

    const ua = new Parser.parse(userAgent);
    extend(this, ua);

    // Edge simulator overrides
    if (this.source === "Mozilla/5.0 (Windows NT 10.0; Win64; x64)") {
      this.browser = "Edge";
      this.isEdge = true;
      this.version = "12.0";
    }

    this.screenHeight = options.screenHeight;

    this.platform = platform.parse(userAgent);
  }

  get isWindows7() {
    return this.os.toLowerCase() === "windows 7";
  }

  get isTouchDevice() {
    return this.isTablet || this.isMobile;
  }

  // Experiences
  get desktopExperience() {
    return true;
  }

  get mobileExperience() {
    return false;
  }

  get isMobile() {
    return !this.isDesktop && !this.isTablet;
  }

  get isMobileSafari() {
    return this.isiPod || this.isiPhone || this.isiPad;
  }

  get useInactivity() {
    // The only time we don't use inactivity is for mobile safari that
    // is not an ipad.
    return true;
  }

  get showPersistantChapterCover() {
    return false;
  }

  get canInitiallyAutoplay() {
    return this.isDesktop;
  }
}
